<template>
  <div class="case">
    <banner img="../assets/img/bgtop.jpg" title="智慧工地-经典案例" />
    <div class="case-section" v-loading="loading">
      <div class="case-section-content">
        <div class="case-section-content-list" v-for="(cas,index) in caseList" :key="index">
          <img v-lazy="cas.Img" />
          <div class="content-list-abstract" :class="{'abstract-active' : index%2!=1}">
            <p class="abstract-title">{{cas.Title}}</p>
            <p class="abstract-content">{{cas.Content}}</p>
            <!-- <div class="more">
              <router-link
                class="text-decoration"
                :to="{ name: 'case', params: { id: cas.Id }}"
              >
                <span>more</span>
                <img src="../assets/img/sanjiao.png" />
              </router-link>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner
  },
  data() {
    return {
      loading: false,
      caseList: [{
		Img:'https://file.jxth.com.cn/group1/M01/00/25/dSm0ymDBaP2ALA7EAClE8TQsxOQ172.png',
		Title:'江西省港口集团',
		Content:'2020年9月，我司历经多年研发的企业级智慧工地SAAS平台，在江西省港口集团正式启用。为我省水利，水运项目建设管理提供更多元化的管理手段。'
	  },{
		Img:'https://file.jxth.com.cn/group1/M02/00/25/dSm0ymDBabmADbxEADZK-0TOtjg786.png',
		Title:'江西省信江航电枢纽项目',
		Content:'2019年5月22日，江西省创建公路水运品质工程推进会在信江八字嘴航电枢纽项目上顺利召开。江西省交通运输厅副厅长王昭春同志，听取我司智慧工地管理平台工作汇报。'
	  },{
		Img:'https://file.jxth.com.cn/group1/M03/00/25/dSm0ymDBag-AQdXZACgj-eKO6Eo834.png',
		Title:'万安枢纽二线船闸',
		Content:'2019年12月，万安枢纽二线船闸工程顺利开工，是有着坐拥全国前五，世界前十的超高水头单级船闸。我司主要参与物联网智慧工地管理系统的建设工作。'
	  },{
		Img:'https://file.jxth.com.cn/group1/M00/00/25/dSm0ymDBaneAZ8gvAAtnMb_QzOE552.png',
		Title:'贵州平罗高速',
		Content:'2017年6月，交通运输部安全总监成平视察平罗高速智慧管理中心，听取我司承建的《平罗高速特大桥可视化智慧管理系统》工作汇报。'
	  },{
		Img:'https://file.jxth.com.cn/group1/M01/00/25/dSm0ymDBatCAAIY0AAPlnRGNTRY425.png',
		Title:'九江一桥项目管理',
		Content:'2016年7月，九江一桥加工改造项目项目管理系统正式上线，为九江一桥项目建设提供强有力的数据支持。'
	  },{
		Img:'https://file.jxth.com.cn/group1/M02/00/25/dSm0ymDBaxGAamYtAAlUwgDp3Go684.png',
		Title:'南昌金开集团',
		Content:'2021年5月，南昌金开集团工程办公系统上线启动，该系统平台能够很好的解决城市投资规划建设中，项目集中管控难、目标紊乱、手段单一等问题。'
	  },{
		Img:'https://file.jxth.com.cn/group1/M03/00/25/dSm0ymDBa2SAVnsRAA_1e0xOdyQ986.png',
		Title:'南昌市公路局',
		Content:'2018年10月，南昌市公路局项目管理系统上线。已服务S416万八线、乔西线等多个国省道建设或改造项目。'
	  },{
		Img:'https://file.jxth.com.cn/group1/M00/00/25/dSm0ymDBa9CAAbwxAAJr4MBMMeg055.png',
		Title:'智慧监理云',
		Content:'2018年6月，我司自主研发的监理云管理系统正式启用，系统以监理企业管理为思路，强化企业运维管理、项目标准化管理水平。先后在江西、浙江、山东、等多个省市，共计服务监理单位20余家。'
	  },{
		Img:'https://file.jxth.com.cn/group1/M01/00/25/dSm0ymDBbC2AGktgAAe726uDjUw616.png',
		Title:'江西省交通建设工程质量监督管理局',
		Content:'我司自自主研发的，交通质量安全监督管理平台在我省交通建设工程工程质量监督管理局正式上线，为我省交通工程质量水平及口碑添砖加瓦。同时为我司在之后的项目管理、智慧工地等一系列管理系统奠定了良好的基础。'
	  }]
    };
  },
  mounted() {
	  
  }
};
</script>

 <style lang="scss" scoped>
.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;

  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: 400px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid pink;

        img {
          width: 612px;
          height: 314px;
        }
        .content-list-abstract {
          width: 350px;
          height: 350px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            color: #e13834;
          }
          .abstract-content {
            height: 200px;
			line-height: 1.5;
            color: #484848;
            font-size: 15px;
            // overflow: hidden;
            // text-overflow: ellipsis;
            // display: -webkit-box;
            // -webkit-line-clamp: 18;
            // -webkit-box-orient: vertical;
            // white-space: normal !important;
            // word-wrap: break-word;
            //border: 1px solid pink;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .abstract-active {
          order: -1;
        }
      }
    }
  }
}
</style>